import { defineStore } from 'pinia'
import type { Infotainment } from '/types/infotainment'
import type * as UserList from '/vue/types/user_list'

export const useUserListStore = defineStore('userList', {
  state: () => ({
    so: '',
    users: [] as UserList.User[],
    infotainments: [] as Infotainment[],
    page: 1,
    hasMore: false,
    restrict: null as UserList.Restrict | null,
  }),
  actions: {
    clear() {
      this.$reset()
    },

    hasUserId(id: number) {
      return this.users.some((u) => u.id === id)
    },
  },
})
